import { IHttpClient } from '@/core/services/http'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { ID } from '@/core/types/models/id.model'
import { airportResolver } from '../resolvers/airport.resolver'
import { AirportResponse } from '../types/api-responses/airport-response'

type Params = {
  search?: string
  countryId?: ID
}

export function createGetAirportsUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (
    { search = '', countryId }: Params,
    { controller }: { controller?: AbortController } = {},
    accountType = AccountType.CUSTOMER,
  ) {
    const res = await httpClient.version('v1').get<{
      data: AirportResponse[]
    }>(`/website/${accountType}/getAirportsByCountry`, {
      params: {
        search,
        country_id: countryId,
        type: 'airport',
      },
      signal: controller?.signal,
    })

    return airportResolver(res.data.data)
  }
}
